"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _actions = require("egov-ui-kit/redux/form/actions");

var _actions2 = require("egov-ui-framework/ui-redux/screen-configuration/actions");

var formConfig = {
  name: "landDetails",
  fields: {
    characterOfPremises: {
      id: "characterOfPremises",
      jsonPath: "Properties[0].buildingdetails.characterOfPremises",
      type: "singleValueList",
      floatingLabelText: "Character of Premises",
      numcols: 6,
      gridDefination: {
        xs: 12,
        sm: 6
      },
      style: {
        width: "100%"
      },
      updateDependentFields: function updateDependentFields(_ref) {
        var formKey = _ref.formKey,
            field = _ref.field,
            dispatch = _ref.dispatch,
            state = _ref.state;

        dispatch((0, _actions.setFieldProperty)("propertyAddress", "characterOfPremises", "value", field.value));
        dispatch((0, _actions2.prepareFinalObject)("Properties[0].buildingdetails.characterOfPremises", field.value));
      }
    },
    acre: {
      id: "acre",
      jsonPath: "Properties[0].buildingdetails.acre",
      type: "textfield",
      floatingLabelText: "Acre",
      updateDependentFields: function updateDependentFields(_ref2) {
        var formKey = _ref2.formKey,
            field = _ref2.field,
            dispatch = _ref2.dispatch,
            state = _ref2.state;

        dispatch((0, _actions.setFieldProperty)("propertyAddress", "acre", "value", field.value));
        dispatch((0, _actions2.prepareFinalObject)("Properties[0].buildingdetails.acre", field.value));
      }
    },
    bigha: {
      id: "bigha",
      jsonPath: "Properties[0].buildingdetails.bigha",
      type: "textfield",
      floatingLabelText: "Bigha",
      updateDependentFields: function updateDependentFields(_ref3) {
        var formKey = _ref3.formKey,
            field = _ref3.field,
            dispatch = _ref3.dispatch,
            state = _ref3.state;

        dispatch((0, _actions.setFieldProperty)("propertyAddress", "bigha", "value", field.value));
        dispatch((0, _actions2.prepareFinalObject)("Properties[0].buildingdetails.bigha", field.value));
      }
    },
    chatak: {
      id: "chatak",
      jsonPath: "Properties[0].buildingdetails.chatak",
      type: "textfield",
      floatingLabelText: "Chatak",
      updateDependentFields: function updateDependentFields(_ref4) {
        var formKey = _ref4.formKey,
            field = _ref4.field,
            dispatch = _ref4.dispatch,
            state = _ref4.state;

        dispatch((0, _actions.setFieldProperty)("propertyAddress", "chatak", "value", field.value));
        dispatch((0, _actions2.prepareFinalObject)("Properties[0].buildingdetails.chatak", field.value));
      }
    },
    cottah: {
      id: "cottah",
      type: "textfield",
      floatingLabelText: "Cottah",
      jsonPath: "Properties[0].buildingdetails.cottah",
      updateDependentFields: function updateDependentFields(_ref5) {
        var formKey = _ref5.formKey,
            field = _ref5.field,
            dispatch = _ref5.dispatch,
            state = _ref5.state;

        dispatch((0, _actions.setFieldProperty)("propertyAddress", "cottah", "value", field.value));
        dispatch((0, _actions2.prepareFinalObject)("Properties[0].buildingdetails.cottah", field.value));
      }
    },
    satak: {
      id: "satak",
      type: "textfield",
      floatingLabelText: "Satak",
      jsonPath: "Properties[0].buildingdetails.satak",
      updateDependentFields: function updateDependentFields(_ref6) {
        var formKey = _ref6.formKey,
            field = _ref6.field,
            dispatch = _ref6.dispatch,
            state = _ref6.state;

        dispatch((0, _actions.setFieldProperty)("propertyAddress", "satak", "value", field.value));
        dispatch((0, _actions2.prepareFinalObject)("Properties[0].buildingdetails.satak", field.value));
      }
    },
    sqMt: {
      id: "sqMt",
      jsonPath: "Properties[0].buildingdetails.sqMt",
      type: "textfield",
      floatingLabelText: "Sq Mt",
      updateDependentFields: function updateDependentFields(_ref7) {
        var formKey = _ref7.formKey,
            field = _ref7.field,
            dispatch = _ref7.dispatch,
            state = _ref7.state;

        dispatch((0, _actions.setFieldProperty)("propertyAddress", "sqMt", "value", field.value));
        dispatch((0, _actions2.prepareFinalObject)("Properties[0].buildingdetails.sqMt", field.value));
      }
    },
    sqFt: {
      id: "sqFt",
      jsonPath: "Properties[0].buildingdetails.sqFt",
      type: "textfield",
      floatingLabelText: "Sq Ft",
      updateDependentFields: function updateDependentFields(_ref8) {
        var formKey = _ref8.formKey,
            field = _ref8.field,
            dispatch = _ref8.dispatch,
            state = _ref8.state;

        dispatch((0, _actions.setFieldProperty)("propertyAddress", "sqFt", "value", field.value));
        dispatch((0, _actions2.prepareFinalObject)("Properties[0].buildingdetails.sqFt", field.value));
      }
    }
  },
  afterInitForm: function afterInitForm(action, store, dispatch) {
    var characterOfPremiseTypeDropDownData = [{
      name: "Vacant Land",
      code: "Vacant Land",
      label: "Vacant Land",
      value: "Vacant Land"
    }, {
      name: "Water Body",
      code: "Water Body",
      label: "Water Body",
      value: "Water Body"
    }, {
      name: "Khatal",
      code: "Khatal",
      label: "Khatal",
      value: "Khatal"
    }, {
      name: "Land With Tank",
      code: "Land With Tank",
      label: "Land With Tank",
      value: "Land With Tank"
    }, {
      name: "Constructed Building",
      code: "Constructed Building",
      label: "Constructed Building",
      value: "Constructed Building"
    }, {
      name: "Under Construction",
      code: "Under Construction",
      label: "Under Construction",
      value: "Under Construction"
    }];
    dispatch((0, _actions.setFieldProperty)("landDetails", "characterOfPremises", "dropDownData", characterOfPremiseTypeDropDownData));
  },
  action: "",
  redirectionRoute: "",
  saveUrl: "",
  isFormValid: false
};

exports.default = formConfig;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/config/forms/specs/PropertyTaxPay/landDetails.js
// module id = 1681
// module chunks = 1137